import React from 'react';
import PropTypes from 'prop-types';

function RightArrow({ active, activeColor, color }) {
  return (
    <path
      d="M216.548 222.333C216.09 222.324 215.579 222.328 215.001 222.341C212.689 222.397 209.293 222.617 205.292 222.98C201.291 223.343 196.687 223.848 194.171 224.235C191.655 224.623 191.229 224.893 188.742 227.196C186.254 229.499 181.707 233.832 179.012 236.515C176.317 239.197 175.477 240.227 174.975 241.024C174.474 241.821 174.139 242.676 174.162 243.783C174.186 244.889 174.476 245.767 174.975 246.54C175.477 247.336 176.317 248.368 179.012 251.05C181.707 253.732 186.254 258.066 188.742 260.368C191.229 262.67 191.655 262.941 194.171 263.329C196.687 263.716 201.291 264.221 205.292 264.584C209.293 264.947 212.689 265.169 215.001 265.224C217.313 265.279 218.539 265.168 219.745 264.786C220.951 264.404 222.135 263.751 223.129 262.867C224.124 261.983 224.929 260.867 225.456 259.938C225.983 259.009 226.235 258.265 226.506 256.722C226.777 255.18 227.069 252.839 227.22 250.448C227.364 248.175 227.397 243.935 227.395 243.783C227.396 243.63 227.364 239.388 227.22 237.116C227.069 234.725 226.777 232.384 226.506 230.842C226.235 229.299 225.983 228.556 225.456 227.626C224.929 226.698 224.124 225.582 223.129 224.697C222.135 223.813 220.951 223.16 219.745 222.778C218.84 222.492 217.925 222.358 216.548 222.333Z"
      fill={active ? activeColor : color}
    />
  );
}

RightArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

RightArrow.defaultProps = {
  active: false,
  activeColor: '#000000',
  color: '#D7DEE6',
};

export default RightArrow;
